import { Controller } from '@hotwired/stimulus'
import DropzoneController from './dropzone'
import SnackBarController from './snack-bar'

export default class DropzoneManagerController extends Controller<HTMLBodyElement> {
  declare readonly dropzoneOutlets: DropzoneController[]
  declare readonly hasDropzoneOutlet: boolean
  declare readonly snackBarOutlet: SnackBarController

  static outlets = ['dropzone', 'snack-bar']

  connect() {
    this.element.addEventListener('dragenter', this.#handleDragenter)
    this.element.addEventListener('dragleave', this.#handleDragleave)
    this.element.addEventListener('dragover', this.#handleDragover)
    this.element.addEventListener('drop', this.#handleDrop)
    this.element.addEventListener('mouseenter', this.#cancelDrag)
  }

  disconnect() {
    this.element.removeEventListener('dragenter', this.#handleDragenter)
    this.element.removeEventListener('dragleave', this.#handleDragleave)
    this.element.removeEventListener('dragover', this.#handleDragover)
    this.element.removeEventListener('drop', this.#handleDrop)
    this.element.removeEventListener('mouseenter', this.#cancelDrag)
  }

  // Private methods

  #cancelDrag = () => {
    this.element.classList.remove('dragging')

    if (!this.hasDropzoneOutlet) return

    this.dropzoneOutlets.forEach(dropzone => {
      dropzone.cancelDrag()
    })
  }

  #droppedOnZone(target: EventTarget | null) {
    if (!target) return false
    return this.dropzoneOutlets.some(dropzone => dropzone.element.contains(target as HTMLElement))
  }

  #handleDragenter = () => {
    this.element.classList.add('dragging')
  }

  #handleDragleave = (event: DragEvent) => {
    const draggingInsideDocument = event.relatedTarget

    if (draggingInsideDocument) return

    this.element.classList.remove('dragging')
  }

  #handleDragover = (event: DragEvent) => {
    event.preventDefault()
  }

  #handleDrop = (event: DragEvent) => {
    if (this.hasDropzoneOutlet) {
      // Only prevent default action if one or more dropzones exist on the page
      event.preventDefault()

      // Let the user know if they missed the dropzone
      if (!this.#droppedOnZone(event.target)) {
        this.snackBarOutlet.add('Files must be dropped onto a dropzone. Please try again.')
      }
    }

    this.element.classList.remove('dragging')
  }
}
